import { render, staticRenderFns } from "./RecipeFeed.vue?vue&type=template&id=0de4ec9e&scoped=true"
import script from "./RecipeFeed.vue?vue&type=script&lang=js"
export * from "./RecipeFeed.vue?vue&type=script&lang=js"
import style0 from "./RecipeFeed.vue?vue&type=style&index=0&id=0de4ec9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de4ec9e",
  null
  
)

export default component.exports